import { render } from "./SeminarCard.vue?vue&type=template&id=1111afc9&scoped=true"
import script from "./SeminarCard.vue?vue&type=script&lang=js"
export * from "./SeminarCard.vue?vue&type=script&lang=js"

import "./SeminarCard.vue?vue&type=style&index=0&id=1111afc9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1111afc9"]])

export default __exports__